"use client";

import { useEffect } from "react";
import { useCookieBanner } from "~/hooks/useCookieBanner";
import { useCookieSettings } from "~/hooks/useCookieSettings";
import { useTranslations } from "~/hooks/useTranslations";

export default function FooterCookieSettings() {
  const t = useTranslations();

  const { showBanner } = useCookieBanner();
  const { necessary } = useCookieSettings();

  useEffect(() => {
    if (!necessary) {
      showBanner();
    }
  }, [necessary, showBanner]);

  return (
    <button
      className="text-left hover:underline"
      type="button"
      onClick={showBanner}
    >
      {t.cookieSettings}
    </button>
  );
}
